<template>
  <b-row class="dashboard-cards">
    <b-col
      cols="12"
      md="6"
    >
      <b-card
        class="mb-1 dashboard-bcard clickable-card"
        @click="navigateToQuotes"
      >
        <div class="d-flex align-items-center mb-1">
          <feather-icon
            icon="FileTextIcon"
            size="22"
            class="mr-1 text-dark"
          />
          <span class="card-title mb-0">Cotizaciones</span>
          <div class="ml-auto d-flex align-items-center">
            <small class="text-muted mr-1">Click para ver</small>
            <feather-icon
              icon="ArrowRightIcon"
              size="16"
              class="text-muted"
            />
          </div>
        </div>
        <div
          v-if="loading"
          class="dashboard-loader"
        >
          <b-spinner
            variant="primary"
            label="Cargando..."
          />
          <span class="loader-text">Cargando cotizaciones...</span>
        </div>
        <div
          v-else
          class="dashboard-card-states"
        >
          <div
            v-for="q in quoteStates"
            :key="q.status"
            class="dashboard-state-card"
            :class="'border-' + quoteVariant(q.status)"
          >
            <div class="state-value">
              {{ q.total }}
            </div>
            <div class="state-label">
              {{ q.status }}
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-card
        class="mb-1 dashboard-bcard clickable-card"
        @click="navigateToOrders"
      >
        <div class="d-flex align-items-center mb-1">
          <feather-icon
            icon="ShoppingCartIcon"
            size="22"
            class="mr-1 text-dark"
          />
          <span class="card-title mb-0">Pedidos</span>
          <div class="ml-auto d-flex align-items-center">
            <small class="text-muted mr-1">Click para ver</small>
            <feather-icon
              icon="ArrowRightIcon"
              size="16"
              class="text-muted"
            />
          </div>
        </div>
        <div
          v-if="loading"
          class="dashboard-loader"
        >
          <b-spinner
            variant="primary"
            label="Cargando..."
          />
          <span class="loader-text">Cargando pedidos...</span>
        </div>
        <div
          v-else
          class="dashboard-card-states"
        >
          <div
            v-for="o in orderStates"
            :key="o.status"
            class="dashboard-state-card"
            :class="'border-' + orderVariant(o.status)"
          >
            <div class="state-value">
              {{ o.total }}
            </div>
            <div class="state-label">
              {{ o.status }}
            </div>
          </div>
        </div>
      </b-card>
    </b-col>

    <!-- Venta caída del período -->
    <b-col cols="12">
      <b-card
        class="mb-1 dashboard-bcard clickable-card"
        @click="navigateToLostSales"
      >
        <div class="d-flex align-items-center mb-1">
          <feather-icon
            icon="TrendingDownIcon"
            size="22"
            class="mr-1 text-dark"
          />
          <span class="card-title mb-0">Venta caída</span>
          <div class="ml-auto d-flex align-items-center">
            <small class="text-muted mr-1">Click para ver</small>
            <feather-icon
              icon="ArrowRightIcon"
              size="16"
              class="text-muted"
            />
          </div>
        </div>
        <div
          v-if="loading"
          class="dashboard-loader"
        >
          <b-spinner
            variant="primary"
            label="Cargando..."
          />
          <span class="loader-text">Cargando venta caída...</span>
        </div>
        <div
          v-else-if="lostSales"
          class="dashboard-card-states"
        >
          <div class="dashboard-state-card border-danger">
            <div class="state-value">
              {{ lostSales.caido }}
            </div>
            <div class="state-label">
              Unidades caídas
            </div>
          </div>
          <div class="dashboard-state-card border-warning">
            <div class="state-value">
              {{ lostSales.porcentaje_sobre_cotizado }}%
            </div>
            <div class="state-label">
              Sobre lo cotizado ({{ lostSales.cotizado_en_periodo }} u.)
            </div>
          </div>
          <div class="dashboard-state-card border-secondary">
            <div class="state-value">
              {{ lostSales.cotizaciones }}
            </div>
            <div class="state-label">
              Cotizaciones afectadas
            </div>
          </div>
          <!-- Montos solo para administración: el backend los omite para vendedores -->
          <div
            v-for="m in lostSales.monto_por_moneda || []"
            :key="m.code"
            class="dashboard-state-card border-dark"
          >
            <div class="state-value">
              {{ m.symbol }}{{ formatAmount(m.monto) }}
            </div>
            <div class="state-label">
              Monto caído {{ m.code }}
            </div>
          </div>
          <div
            v-if="lostSales.monto_por_moneda && !lostSales.monto_por_moneda.length"
            class="dashboard-state-card border-dark"
          >
            <div class="state-value">
              Q0.00
            </div>
            <div class="state-label">
              Monto caído
            </div>
          </div>
        </div>
        <div
          v-else
          class="text-muted"
        >
          Sin datos de venta caída para el período.
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'DashboardCards',
  props: {
    quoteStates: {
      type: Array,
      default: () => [],
    },
    orderStates: {
      type: Array,
      default: () => [],
    },
    lostSales: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    navigateToQuotes() {
      this.$router.push({ name: 'sales-customer-quotes' })
    },
    navigateToOrders() {
      this.$router.push({ name: 'sales-customer-orders' })
    },
    navigateToLostSales() {
      this.$router.push({ name: 'sales-lost-sales' })
    },
    formatAmount(value) {
      return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    quoteVariant(status) {
      switch (status) {
        case 'En Proceso': return 'primary'
        case 'Enviado': return 'info'
        case 'Aceptado': return 'success'
        case 'Declinado': return 'danger'
        case 'Correcciones': return 'warning'
        case 'Pedido': return 'secondary'
        case 'Venta Caída': return 'danger'
        default: return 'light'
      }
    },
    orderVariant(status) {
      switch (status) {
        case 'Pendiente': return 'primary'
        case 'Autorizado': return 'success'
        case 'Despachado': return 'info'
        case 'Facturado': return 'secondary'
        case 'Correcciones': return 'warning'
        case 'Rechazado': return 'danger'
        case 'Anulado': return 'dark'
        default: return 'light'
      }
    },
  },
}
</script>

<style scoped>
.dashboard-cards {
  width: 100%;
  margin-bottom: 1.5rem;
}
.dashboard-bcard {
  min-height: 120px;
  padding: 1.2rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.clickable-card {
  cursor: pointer !important;
  position: relative;
  overflow: hidden;
}
.clickable-card:hover {
  transform: translateY(-3px);
}
.clickable-card:active {
  transform: translateY(-1px);
}
.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #222;
}
.dashboard-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  gap: 1rem;
}
.loader-text {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}
.dashboard-card-states {
  display: flex;
  flex-wrap: wrap;
  gap: 1.1rem;
  margin-top: 0.5rem;
}
.dashboard-state-card {
  border-width: 2px !important;
  border-style: solid;
  border-radius: 10px;
  padding: 0.7rem 1.1rem;
  min-width: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fafbfc;
  transition: box-shadow 0.2s, border-color 0.2s;
  box-shadow: 0 1px 4px rgba(66,165,245,0.04);
}
.dashboard-state-card:hover {
  box-shadow: 0 4px 16px rgba(66,165,245,0.10);
}
.state-label {
  font-size: 1.05rem;
  font-weight: 500;
  color: #555;
  margin-top: 0.2rem;
}
.state-value {
  font-size: 2rem;
  font-weight: 700;
  color: #222;
}
/* Indicador de click más visible */
.clickable-card .ml-auto {
  transition: all 0.3s ease;
}
.clickable-card:hover .ml-auto {
  transform: translateX(3px);
}
</style>
